import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
const GlobalLoading = (props) => {
  const { tip } = props;
  return (
    <div className="global-loading">
      {/* <div className="global-loading-content">
        <div className="global-loading-content-block">
          <img
            className="global-loading-content-img"
            src={require('assets/images/loading.gif')}
          ></img>
          <span className='global-loading-content-tip'>{tip}</span>
        </div>
      </div> */}
    </div>
  );
};

let instance = null;
GlobalLoading.service = function (properties) {
  if (instance) return instance;
  const props = { tip: "加载中", ...properties };
  const div = document.createElement("div");
  document.body.appendChild(div);
  ReactDOM.render(React.createElement(GlobalLoading, props), div);
  instance = {
    close() {
      instance = null;
      ReactDOM.unmountComponentAtNode(div);
      // document.body.removeChild(div);
    },
  };
  return instance;
};

export default GlobalLoading;
